import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import BaseContainer from "../ui/BaseContainer/BaseContainer";
import BaseLink from "../ui/BaseLink";
import Social from "../ui/icons/Social";
import classes from "./Footer.module.scss";

const Footer = () => {
  const { t } = useTranslation();

  const socials = t("footer.socials", { returnObjects: true });

  return (
    <BaseContainer className={classes.footer} element="footer">
      <ul className={classes["footer-info"]}>
        <li>
          <a href="tel:+998712000881">+ 998 (71) 200 08 81</a>
        </li>
        <li>
          <a href="mailto:info@lavina.tech">info@lavina.tech</a>
        </li>
      </ul>
      <ul className={classes["footer-nav"]}>
        <li>
          <HashLink smooth to="/main#services" component={BaseLink}>
            {t("services.title")}
          </HashLink>
        </li>
        <li>
          <HashLink smooth to="/main#team" component={BaseLink}>
            {t("navigation.our-team")}
          </HashLink>
        </li>
        <li>
          <Link to="/jobs" component={BaseLink}>
            {t("navigation.jobs")}
          </Link>
        </li>
      </ul>
      <ul className={classes["footer-socials"]}>
        {socials.map((social) => (
          <li key={social.type}>
            <Social type={social.type} href={social.link} target="_blank" />
          </li>
        ))}
      </ul>
    </BaseContainer>
  );
};

export default Footer;
